var chunkMapping = {
	"1087": [
		1087
	],
	"1444": [
		31444
	],
	"1791": [
		61791
	],
	"1998": [
		41998
	],
	"1999": [
		61999
	],
	"2815": [
		2815
	],
	"5052": [
		45052
	],
	"5482": [
		95482
	],
	"6325": [
		66325
	],
	"6473": [
		16473
	],
	"6940": [
		96940
	],
	"9276": [
		29276
	],
	"9839": [
		99839
	]
};
var idToExternalAndNameMapping = {
	"1087": [
		"default",
		"./AllBrands",
		26227
	],
	"2815": [
		"default",
		"./MyAccount",
		26227
	],
	"16473": [
		"default",
		"./ContentfulPage",
		26227
	],
	"29276": [
		"default",
		"./Review",
		26227
	],
	"31444": [
		"default",
		"./Checkout",
		26227
	],
	"41998": [
		"default",
		"./SkinDiagnostic",
		26227
	],
	"45052": [
		"default",
		"./MyBag",
		26227
	],
	"61791": [
		"default",
		"./OrderConfirmation",
		26227
	],
	"61999": [
		"default",
		"./Resolver",
		49542
	],
	"66325": [
		"default",
		"./MastheadComponent",
		49542
	],
	"95482": [
		"default",
		"./Section",
		49542
	],
	"96940": [
		"default",
		"./Pdp",
		26227
	],
	"99839": [
		"default",
		"./ListingPageComponent",
		49542
	]
};
var idToRemoteMap = {
	"1087": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"2815": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"16473": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"29276": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"31444": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"41998": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"45052": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"61791": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"61999": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm"
		}
	],
	"66325": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm"
		}
	],
	"95482": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm"
		}
	],
	"96940": [
		{
			"externalType": "script",
			"name": "beautyFrontendPlp"
		}
	],
	"99839": [
		{
			"externalType": "script",
			"name": "ldpViewResolverSdm"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"1087": {
		"shareScope": "default",
		"name": "./AllBrands",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"2815": {
		"shareScope": "default",
		"name": "./MyAccount",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"16473": {
		"shareScope": "default",
		"name": "./ContentfulPage",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"29276": {
		"shareScope": "default",
		"name": "./Review",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"31444": {
		"shareScope": "default",
		"name": "./Checkout",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"41998": {
		"shareScope": "default",
		"name": "./SkinDiagnostic",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"45052": {
		"shareScope": "default",
		"name": "./MyBag",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"61791": {
		"shareScope": "default",
		"name": "./OrderConfirmation",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"61999": {
		"shareScope": "default",
		"name": "./Resolver",
		"externalModuleId": 49542,
		"remoteName": "ldpViewResolverSdm"
	},
	"66325": {
		"shareScope": "default",
		"name": "./MastheadComponent",
		"externalModuleId": 49542,
		"remoteName": "ldpViewResolverSdm"
	},
	"95482": {
		"shareScope": "default",
		"name": "./Section",
		"externalModuleId": 49542,
		"remoteName": "ldpViewResolverSdm"
	},
	"96940": {
		"shareScope": "default",
		"name": "./Pdp",
		"externalModuleId": 26227,
		"remoteName": "beautyFrontendPlp"
	},
	"99839": {
		"shareScope": "default",
		"name": "./ListingPageComponent",
		"externalModuleId": 49542,
		"remoteName": "ldpViewResolverSdm"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}